// gloss
// why: linkifyHtml must run after DOMPurify sanitization; running it on unsanitized HTML operates
// why: on untrusted input.
export const linkifyHtml = (html: string): string => {
  if (!html) return '';
  if (typeof window === 'undefined') return html;

  const urlRegex = /(https?:\/\/[^\s<]+[^\s<.,:;"')\]\\])/g;
  const div = document.createElement('div');
  div.innerHTML = html;

  const walkTextNodes = (node: Node): void => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent || '';
      if (!text.trim()) return;

      const matches: Array<{ index: number; length: number; url: string }> = [];
      let m;
      while ((m = urlRegex.exec(text)) !== null) {
        matches.push({ index: m.index, length: m[0].length, url: m[0] });
      }

      if (matches.length === 0) return;

      const fragment = document.createDocumentFragment();
      let lastIndex = 0;

      for (const match of matches) {
        if (match.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }

        const a = document.createElement('a');
        a.href = match.url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.className = 'text-blue-500 hover:underline';
        a.textContent = match.url;
        fragment.appendChild(a);

        lastIndex = match.index + match.length;
      }

      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      node.parentNode?.replaceChild(fragment, node);
    } else if (node.nodeType === Node.ELEMENT_NODE && (node as Element).tagName !== 'A') {
      Array.from(node.childNodes).forEach(walkTextNodes);
    }
  };

  Array.from(div.childNodes).forEach(walkTextNodes);
  return div.innerHTML;
};
